export default "__VITE_ASSET__BYoKya2p__"